const GlobalAlerts = require('global_alerts');


function RefreshKeys() {
  const $appKey = $('#appKey');
  const $appSecret = $('#appSecret');
  const $contaCorrente = $('#contaCorrente');
  const $integrationBody = $('#integration-body');

  // Se não tiver o campo de conta corrente pra atualizar, ignora essa funcao
  if (!$contaCorrente.length) {
    return;
  }

  $integrationBody.overlay();

  $contaCorrente.selectize({
    maxItems: 1,
    selectOnTab: true,
    hideSelected: true,
    searchField: 'descricao',
    labelField: 'descricao',
    valueField: 'nCodCC'
  });

  const onChangeHandler = () => {
    if (!$appKey.val().trim() || !$appSecret.val().trim()) {
      return;
    }

    $integrationBody.overlay('show');

    $.get(route('app.settings.integracoes.omie.conta-corrente-json', {
      appKey: $appKey.val().trim(),
      appSecret: $appSecret.val().trim()
    }))
      .done((data) => {
        const contaCorrenteSelectize = $contaCorrente[0].selectize;

        contaCorrenteSelectize.enable();
        contaCorrenteSelectize.clearOptions();
        contaCorrenteSelectize.addOption(data);
      })
      .fail((response) => {
        GlobalAlerts.createAndShow({
          message: response.responseJSON,
          type: 'danger'
        });
      })
      .always(() => {
        $integrationBody.overlay('hide');
      })
  };

  $appKey.on('change', onChangeHandler);
  $appSecret.on('change', onChangeHandler);
}


module.exports = RefreshKeys;
